import { useLocation as UseLocation } from "react-router-dom";

const preparedLink = (to) => {
  const location = UseLocation();
  let pathname = to || location.pathname;
  return {
    pathname: pathname.replace(/\/\//g, "/"),
  };
};
export default preparedLink;